// 渲染短格式的天干地支标签（用于大运/流年列表）
export const STEMS_SET = new Set(["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"]);
export const BRANCHES_SET = new Set(["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"]);
/**
 * 生成六十甲子（顺序）
 * 规则：天干按 10 周期，地支按 12 周期，取前 60 项配对
 */
export const JIAZI_ARRAY = Array.from({ length: 60 }, (_, i) => {
  const stem = STEMS_SET[i % STEMS_SET.size];
  const branch = BRANCHES_SET[i % BRANCHES_SET.size];
  return `${stem}${branch}`;
});

// 同时导出 Set 形式（用于快速查找/去重）
export const JIAZI_SET = new Set(JIAZI_ARRAY);


// 地支对应的藏干（常用顺序）
export const BRANCH_HIDDEN_STEMS = {
  子: ["癸"],
  丑: ["己", "癸", "辛"],
  寅: ["甲", "丙", "戊"],
  卯: ["乙"],
  辰: ["戊", "乙", "癸"],
  巳: ["丙", "戊", "庚"],
  午: ["丁", "己"],
  未: ["己", "丁", "乙"],
  申: ["庚", "壬", "戊"],
  酉: ["辛"],
  戌: ["戊", "辛", "丁"],
  亥: ["壬", "甲"],
};

/**
 * 根据地支或完整柱(pillar)返回该地支对应的藏干数组。
 * 参数可传入单个地支字符（如 "子"）或完整柱字符串（如 "甲子" / "甲子日"），函数会自动解析。
 * 若无法识别返回空数组。
 */
export const getHiddenStems = (branchOrPillar) => {
  if (!branchOrPillar) return [];
  const s = String(branchOrPillar).trim();
  // 若传入整柱，尝试解析出地支
  let branch = s;
  // 如果看起来像多字符柱（包含天干/地支），尝试从中抽出第一个/最后一个汉字地支
  if (s.length > 1) {
    const chars = s.match(/[\u4e00-\u9fff]/g) || [];
    // 取最后一个汉字作为地支（兼容 "甲子"/"甲子日" 等）
    if (chars.length > 0) branch = chars[chars.length - 1];
  }
  return BRANCH_HIDDEN_STEMS[branch] ? [...BRANCH_HIDDEN_STEMS[branch]] : [];
};


export const parsePillar = (pillar) => {
  if (!pillar) return ["", ""];
  const s = String(pillar).trim().replace(/\s+/g, "");
  if (s.length === 0) return ["", ""];
  const first = s[0];
  const last = s[s.length - 1];
  if (STEMS_SET.has(first) && BRANCHES_SET.has(last)) {
    return [first, last];
  }
  const chars = s.match(/[\u4e00-\u9fff]/g) || [];
  return [chars[0] || "", chars[1] || ""];
};

  // ==================== 天干地支颜色映射 ====================
 
export const getStemColor = (stem) => {
  const colors = {
    甲: "text-green-600 bg-green-50",
    乙: "text-green-500 bg-green-50",
    丙: "text-red-600 bg-red-50",
    丁: "text-red-500 bg-red-50",
    戊: "text-yellow-600 bg-yellow-50",
    己: "text-yellow-500 bg-yellow-50",
    庚: "text-gray-600 bg-gray-50",
    辛: "text-gray-500 bg-gray-50",
    壬: "text-blue-600 bg-blue-50",
    癸: "text-blue-500 bg-blue-50",
  };
  return colors[stem] || "text-gray-700 bg-gray-50";
};

export const getStemColor_nobg = (stem) => {
  const colors = {
    甲: "text-green-600",
    乙: "text-green-500",
    丙: "text-red-600",
    丁: "text-red-500",
    戊: "text-yellow-600",
    己: "text-yellow-500",
    庚: "text-gray-600",
    辛: "text-gray-500",
    壬: "text-blue-600",
    癸: "text-blue-500",
  };
  return colors[stem] || "text-gray-700";
};

export const getBranchColor = (branch) => {
  const colors = {
    子: "text-blue-700 bg-blue-100",
    丑: "text-yellow-700 bg-yellow-100",
    寅: "text-green-700 bg-green-100",
    卯: "text-green-600 bg-green-100",
    辰: "text-yellow-700 bg-yellow-100",
    巳: "text-red-700 bg-red-100",
    午: "text-red-600 bg-red-100",
    未: "text-yellow-700 bg-yellow-100",
    申: "text-gray-700 bg-gray-100",
    酉: "text-gray-600 bg-gray-100",
    戌: "text-yellow-700 bg-yellow-100",
    亥: "text-blue-700 bg-blue-100",
  };
    return colors[branch] || "text-gray-700 bg-gray-100";
};

export const getBranchColor_nobg = (branch) => {
  const colors = {
    子: "text-blue-700",
    丑: "text-yellow-700",
    寅: "text-green-700",
    卯: "text-green-600",
    辰: "text-yellow-700",
    巳: "text-red-700",
    午: "text-red-600",
    未: "text-yellow-700",
    申: "text-gray-700",
    酉: "text-gray-600",
    戌: "text-yellow-700",
    亥: "text-blue-700",
  };
    return colors[branch] || "text-gray-700";
};

// 辅助函数：根据字符获取颜色类名
export const getColorClass = (char) => {
    if (STEMS_SET.has(char)) return getStemColor(char);
    if (BRANCHES_SET.has(char)) return getBranchColor(char);

    const map = {
      // 五行
      '金': 'text-wuxing-metal-default',
      '木': 'text-wuxing-wood-default',
      '水': 'text-wuxing-water-default',
      '火': 'text-wuxing-fire-default',
      '土': 'text-wuxing-earth-default',
      // 九星 (五行颜色)
      '天蓬': 'text-wuxing-water-default', '天芮': 'text-wuxing-earth-default', '天芮(禽)': 'text-wuxing-earth-default',
      '天冲': 'text-wuxing-wood-default', '天辅': 'text-wuxing-wood-default', '天禽': 'text-wuxing-earth-default',
      '天心': 'text-wuxing-metal-default', '天柱': 'text-wuxing-metal-default', '天任': 'text-wuxing-earth-default',
      '天英': 'text-wuxing-fire-default',
      // 八门 (五行颜色)
      '休': 'text-wuxing-water-default', '死': 'text-wuxing-earth-default', '伤': 'text-wuxing-wood-default',
      '杜': 'text-wuxing-wood-default', '开': 'text-wuxing-metal-default', '惊': 'text-wuxing-metal-default',
      '生': 'text-wuxing-earth-default', '景': 'text-wuxing-fire-default',
      // 八神 (五行颜色)
      '值符': 'text-wuxing-earth-default', '螣蛇': 'text-wuxing-fire-default', '太阴': 'text-wuxing-metal-default',
      '六合': 'text-wuxing-wood-default', '白虎': 'text-wuxing-metal-default', '玄武': 'text-wuxing-water-default',
      '九地': 'text-wuxing-earth-default', '九天': 'text-wuxing-metal-default',
    };
    return map[char] || '';
};

// 辅助函数：根据字符获取颜色类名
export const getColorClass_nobg = (char) => {
    if (STEMS_SET.has(char)) return getStemColor_nobg(char);
    if (BRANCHES_SET.has(char)) return getBranchColor_nobg(char);

    const map = {
      // 五行
      '金': 'text-wuxing-metal-default',
      '木': 'text-wuxing-wood-default',
      '水': 'text-wuxing-water-default',
      '火': 'text-wuxing-fire-default',
      '土': 'text-wuxing-earth-default',
      // 九星 (五行颜色)
      '天蓬': 'text-wuxing-water-default', '天芮': 'text-wuxing-earth-default', '天芮(禽)': 'text-wuxing-earth-default',
      '天冲': 'text-wuxing-wood-default', '天辅': 'text-wuxing-wood-default', '天禽': 'text-wuxing-earth-default',
      '天心': 'text-wuxing-metal-default', '天柱': 'text-wuxing-metal-default', '天任': 'text-wuxing-earth-default',
      '天英': 'text-wuxing-fire-default',
      // 八门 (五行颜色)
      '休': 'text-wuxing-water-default', '死': 'text-wuxing-earth-default', '伤': 'text-wuxing-wood-default',
      '杜': 'text-wuxing-wood-default', '开': 'text-wuxing-metal-default', '惊': 'text-wuxing-metal-default',
      '生': 'text-wuxing-earth-default', '景': 'text-wuxing-fire-default',
      // 八神 (五行颜色)
      '值符': 'text-wuxing-earth-default', '螣蛇': 'text-wuxing-fire-default', '太阴': 'text-wuxing-metal-default',
      '六合': 'text-wuxing-wood-default', '白虎': 'text-wuxing-metal-default', '玄武': 'text-wuxing-water-default',
      '九地': 'text-wuxing-earth-default', '九天': 'text-wuxing-metal-default',
    };
    return map[char] || '';
};
// 渲染带颜色的文本组件
export const ColorText = ({ text, className = '' }) => {
    if (!text) return null;
    return (
      <span className={className}>
        {text.split('').map((char, index) => (
          <span key={index} className={getColorClass(char) || 'text-inherit'}>
            {char}
          </span>
        ))}
      </span>
    );
};

// 渲染带颜色的文本组件
export const ColorText_nobg = ({ text, className = '' }) => {
    if (!text) return null;
    return (
      <span className={className}>
        {text.split('').map((char, index) => (
          <span key={index} className={getColorClass_nobg(char) || 'text-inherit'}>
            {char}
          </span>
        ))}
      </span>
    );
};

export const renderInlinePillar = (pillar) => {
  if (!pillar) return null;
  const [stem, branch] = parsePillar(pillar);
  if (!stem && !branch) return null;
  return (
    <span className="inline-flex items-center gap-2">
      {stem ? (
        <span
          className={`px-2 py-0.5 rounded text-sm font-medium ${getStemColor(
            stem
          )}`}
        >
          {stem}
        </span>
      ) : null}
      {branch ? (
        <span
          className={`px-2 py-0.5 rounded text-sm font-medium ${getBranchColor(
            branch
          )}`}
        >
          {branch}
        </span>
      ) : null}
    </span>
  );
};

export default renderInlinePillar;